import { ErrorLevel } from '@griply/utils';
import { getErrorReporter } from 'shared/services/error-tracking';

import { initAuth } from './authentication';

let initialized = false;
let isReloading = false;

const refresh = async () => {
  if (isReloading) {
    return;
  }
  isReloading = true;
  try {
    const auth = await initAuth();
    if (!auth.currentUser) {
      return;
    }
    await auth.currentUser.reload();
  } catch (error) {
    getErrorReporter().captureException(error, {
      tags: { source: 'auth-token-refresh-on-focus' },
      level: ErrorLevel.Warning,
    });
  } finally {
    isReloading = false;
  }
};

const handleVisibilityChange = () => {
  if (document.visibilityState !== 'visible') {
    return;
  }
  refresh();
};

export const initAuthTokenRefreshOnFocus = () => {
  if (initialized) {
    return;
  }
  initialized = true;

  document.addEventListener('visibilitychange', handleVisibilityChange);
  window.addEventListener('focus', refresh);

  refresh();
};

export const __resetAuthTokenRefreshOnFocusForTests = () => {
  initialized = false;
  isReloading = false;
};
